/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Applied_SuccessInputs */



/**
* | output |
* | --- |
* | "Timing applied successfully" |
*
* @param {Timing_Applied_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_applied_success = /** @type {((inputs?: Timing_Applied_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Applied_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutage appliqué avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing erfolgreich angewendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempistica applicata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Успешно применено временное ограничение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo aplicado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("计时应用成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングが正常に適用されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय सफलतापूर्वक लागू हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cronometragem aplicada com sucesso")
	return /** @type {LocalizedString} */ ("Timing applied successfully")
});